import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class UnitRepository extends CrudRepository {
  constructor () {
    super('core/api/unit/web')
  }

  async getWithPagination (type, page, size) {
    const response = await Repository.get(`${this.resource}/${type}?page=${page}&size=${size}`)
    return response
  }
}
